import { optionsFull_subCategory_loading } from './OptionsPaneLoading.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';

import * as React from 'react';

const styles = require('./OptionsPaneLoading.scss');

export default observer(function OptionsPaneLoading(props: {}) {
    return (
        <div className={styles.messageContainer}>
            <div>
                <Spinner type={SpinnerType.large} />
            </div>
            <div className={styles.messageText}>{loc(optionsFull_subCategory_loading)}</div>
        </div>
    );
});
